module.exports = __webpack_public_path__ + "static/media/Wa.3108253c.png";